/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ContractBeratungsanlassType {
    Neuabschluss = 'Neuabschluss',
    Vertragsaenderung = 'Vertragsaenderung',
    Schadenfall = 'Schadenfall',
    Kundenanfrage = 'Kundenanfrage',
    JaehrlicheUeberpruefung = 'JaehrlicheUeberpruefung',
    Sonstiges = 'Sonstiges'
  }

    export const ContractBeratungsanlassTypeTranslocoMap: Record<ContractBeratungsanlassType, string> = {
    [ContractBeratungsanlassType.Neuabschluss]: 'contractBeratungsanlassType.neuabschluss',
    [ContractBeratungsanlassType.Vertragsaenderung]: 'contractBeratungsanlassType.vertragsaenderung',
    [ContractBeratungsanlassType.Schadenfall]: 'contractBeratungsanlassType.schadenfall',
    [ContractBeratungsanlassType.Kundenanfrage]: 'contractBeratungsanlassType.kundenanfrage',
    [ContractBeratungsanlassType.JaehrlicheUeberpruefung]: 'contractBeratungsanlassType.jaehrlicheUeberpruefung',
    [ContractBeratungsanlassType.Sonstiges]: 'contractBeratungsanlassType.sonstiges',
    };

    export const ContractBeratungsanlassTypeOptions = [
  { value: ContractBeratungsanlassType.Neuabschluss, labelKey: 'contractBeratungsanlassType.neuabschluss' },
  { value: ContractBeratungsanlassType.Vertragsaenderung, labelKey: 'contractBeratungsanlassType.vertragsaenderung' },
  { value: ContractBeratungsanlassType.Schadenfall, labelKey: 'contractBeratungsanlassType.schadenfall' },
  { value: ContractBeratungsanlassType.Kundenanfrage, labelKey: 'contractBeratungsanlassType.kundenanfrage' },
  { value: ContractBeratungsanlassType.JaehrlicheUeberpruefung, labelKey: 'contractBeratungsanlassType.jaehrlicheUeberpruefung' },
  { value: ContractBeratungsanlassType.Sonstiges, labelKey: 'contractBeratungsanlassType.sonstiges' },
    ];

